<template>
  <div class="myFriends">
    <van-tabs v-model="active" :ellipsis="false">
      <van-tab v-show="active == 2">
        <template #title>
          <div style="color: #333333; font-weight: bold; font-size: 0.14rem">
            我的好友（{{ total1 ? total1 : 0 }}人）
          </div>
          <div style="font-size: 0.12rem; color: #333333">
            正式会员
            <span style="color: #ff5d5d">
              （{{ pay_num1 ? pay_num1 : "0" }}人）
            </span>
          </div>
        </template>
        <van-list
          class="ul"
          :style="{ background: finished1 ? 'none' : '#ffffff' }"
          v-model="loading1"
          :finished="finished1"
          finished-text="全部结果"
          @load="onLoad1"
          v-if="!isNone1"
        >
          <FriendsList :friendsList="friendsList1"></FriendsList>
        </van-list>
      </van-tab>

      <van-tab v-show="active == 1">
        <template #title>
          <div style="color: #333333; font-weight: bold; font-size: 0.14rem">
            我的团队（{{ total2 ? total2 : 0 }}人）
          </div>
          <div style="font-size: 0.12rem; color: #333333">
            正式会员
            <span style="color: #ff5d5d">
              （{{ pay_num2 ? pay_num2 : "0" }}人）
            </span>
          </div>
        </template>
        <van-list
          class="ul"
          :style="{ background: finished2 ? 'none' : '#ffffff' }"
          v-model="loading2"
          :finished="finished2"
          finished-text="全部结果"
          @load="onLoad2"
          v-if="!isNone2"
        >
          <FriendsList :friendsList="friendsList2"></FriendsList>
        </van-list>
      </van-tab>
    </van-tabs>

    <!-- 当没有好友时 -->
    <div
      v-if="
        (active == 0 && friendsList1.length == 0 && !loading1) ||
        (active == 1 && friendsList2.length == 0 && !loading2)
      "
      class="noOrder"
      style="
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f3f1f4;
      "
    >
      <img
        src="../../assets/img/empty/img_blank_content@2x.png"
        alt=""
        style="width: 2.17rem; height: 1.75rem; margin-top: 1.8rem"
      />
      <p
        style="
          height: 0.24rem;
          font-size: 0.12rem;
          color: #99999b;
          line-height: 0.24rem;
        "
      >
        您还没有{{ active == 0 ? "好友" : "团队" }}哦~
      </p>
    </div>
  </div>
</template>

<script>
import FriendsList from "../../components/FriendsList";
import { getmygroup } from "../../api/home";
export default {
  components: {
    FriendsList,
  },
  data() {
    return {
      // 我的好友
      friendsList1: [],
      loading1: false,
      finished1: false,
      isNone1: false,
      pay_num1: 0, //正式会员数
      page1: 1,
      total1: 0,
      // 我的团队
      active: 2,
      friendsList2: [],
      loading2: false,
      finished2: false,
      isNone2: false,
      pay_num2: 0, //正式会员数
      page2: 1,
      total2: 0,
    };
  },
  created() {
    // 好友
    this.onLoad1();
    // 团队
    getmygroup({ page: this.page2, type: 2 })
      .then((res) => {
        this.total2 = res.data.backdata.total; // 团队的人数
        this.pay_num2 = res.data.backdata.pay_num; // 团队的正式会员数
      })
      .catch((err) => {
        this.loading2 = false;
      });
  },
  methods: {
    // 我的好友
    onLoad1() {
      this.loading1 = true;
      getmygroup({ page: this.page1, type: 1 })
        .then((res) => {
          this.friendsList1.push(...res.data.backdata.lists);
          this.page1 += 1;
          this.loading1 = false;
          this.total1 = res.data.backdata.total; // 好友人数
          this.pay_num1 = res.data.backdata.pay_num; // 好友的正式会员数
          if (res.data.backdata.lists == 0) {
            this.isNone1 = true;
          } else {
            this.isNone1 = false;
          }
          if (this.friendsList1.length >= res.data.ext.total) {
            this.finished1 = true;
          }
        })
        .catch((err) => {
          this.loading1 = false;
        });
    },
    // 我的团队
    onLoad2() {
      this.loading2 = true;
      getmygroup({ page: this.page2, type: 2 })
        .then((res) => {
          this.friendsList2.push(...res.data.backdata.lists);
          this.page2 += 1;
          this.loading2 = false;
          //    this.total2 = res.data.backdata.total; // 团队的人数
          // this.pay_num2 = res.data.backdata.pay_num; // 团队的正式会员数

          if (res.data.backdata.lists == 0) {
            this.isNone2 = true;
          } else {
            this.isNone2 = false;
          }
          if (this.friendsList2.length >= res.data.ext.total) {
            this.finished2 = true;
          }
        })
        .catch((err) => {
          this.loading2 = false;
        });
    },
  },
};
</script>

<style lang='scss'>
.myFriends {
  padding-top: 0.48rem;
  height: 100%;
  background: #f3f1f4;
  .van-tabs__wrap {
    height: 0.57rem;
    position: fixed;
    z-index: 1;
    width: 100%;
  }
  .van-tab {
    line-height: 0.2rem;
  }
  .van-tabs__content {
    padding-top: 0.56rem;
  }
  .van-tabs__nav--complete {
    height: 0.57rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
  }
  .van-tabs__line {
    width: 1.87rem;
    bottom: 16px;
    height: 2px;
    background-color: #1b1b1b;
  }
  .van-tab {
    opacity: 0.5;

    &:nth-child(1) {
      height: 0.33rem;
      border-right: 1px solid rgba(0, 0, 0, 0.1);
    }
    &:nth-child(2) {
      height: 0.33rem;
      border-left: 1px solid rgba(0, 0, 0, 0.1);
    }

    .van-tab__text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  // 选中
  .van-tab--active {
    opacity: 1;
  }
  // 好友总数
  .myFriends_number {
    width: 100%;
    height: 0.44rem;
    background: #f8f8f8;
    font-size: 0.14rem;
    font-weight: bold;
    color: #333333;
    line-height: 0.44rem;
    text-align: center;
    position: fixed;
    top: 0.49rem;
    left: 0;
    span {
      color: #ff5d5d;
    }
  }
  .ul {
    width: 100%;
  }
}
</style>
